import { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Trash2 } from "lucide-react";

const STATUSES = ["New", "In Progress", "Confirmed", "Completed", "Cancelled"];

export default function OpsConcierge() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/concierge").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);
  const change = async (id, status) => { await api.patch(`/concierge/${id}`, { status }); load(); };
  const remove = async (c) => {
    if (!window.confirm(`Delete "${c.title}"?`)) return;
    try { await api.delete(`/concierge/${c.id}`); toast.success("Deleted"); load(); }
    catch { toast.error("Delete failed"); }
  };
  return (
    <DashboardLayout role="ops">
      <div className="max-w-[1400px] mx-auto px-8 py-10">
        <div className="as-overline">Concierge Ops</div>
        <h1 className="as-serif text-5xl font-light mt-2" data-testid="ops-concierge-title">Bespoke Requests</h1>
        <div className="mt-8 as-card divide-y divide-[#E5DFD2]" data-testid="ops-concierge-list">
          {rows.length === 0 && <div className="p-10 text-center text-[#756E64]">No requests.</div>}
          {rows.map(c => (
            <div key={c.id} className="p-5 flex items-center justify-between gap-6" data-testid={`concierge-row-${c.id}`}>
              <div className="flex items-center gap-4 flex-1">
                <div className="w-10 h-10 rounded-sm bg-[#A47E2A]/10 flex items-center justify-center"><Sparkles size={16} className="as-gold"/></div>
                <div>
                  <div className="text-[#1A1D24]">{c.title}</div>
                  <div className="as-mono text-[10px] text-[#756E64] uppercase tracking-widest mt-0.5">{c.category} · {c.client_name}</div>
                </div>
              </div>
              <select value={c.status} onChange={e => change(c.id, e.target.value)} className="bg-white border border-[#E5DFD2] focus:border-[#A47E2A] focus:outline-none px-3 py-2 rounded-sm text-xs" data-testid={`concierge-status-${c.id}`}>
                {STATUSES.map(s => <option key={s}>{s}</option>)}
              </select>
              <button onClick={() => remove(c)} className="p-1.5 text-[#756E64] hover:text-red-600 hover:bg-red-50 rounded-sm" data-testid={`concierge-delete-${c.id}`}><Trash2 size={14}/></button>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
